module.exports = __webpack_public_path__ + "static/sanyam-3ef088ca3183ab784ee06c0aed9d392a.jpg";